




































import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { defineComponent, computed } from '@vue/composition-api';
import { ParagraphSize } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { SubscriptionConstants } from '../constants/subscription.constants';
import type { SeatType } from '../types/seat-type';
import IncludedFeatures from './IncludedFeatures.vue';

export default defineComponent({
  components: { IncludedFeatures },
  props: {
    module: {
      type: String as PropType<SeatType>,
      default: '',
    },
    moduleHeader: {
      type: String,
      default: '',
    },
    moduleDescription: {
      type: String,
      default: '',
    },
    professionalPrice: {
      type: String,
      default: '',
    },
    professionalDescription: {
      type: String,
      default: '',
    },
    enterpriseDescription: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const professionalChecklist = computed(() =>
      SubscriptionConstants.professionalChecklist(props.module)
    );

    const enterpriseChecklist = computed(() =>
      SubscriptionConstants.enterpriseChecklist(props.module)
    );

    return {
      t,
      ParagraphSize,
      enterpriseChecklist,
      professionalChecklist,
    };
  },
});
